import { createFileRoute } from "@tanstack/react-router";

import { loadMe } from "../features/auth/session";
import { PricingPage } from "../features/marketing/PricingPage";
import { PublicLayout } from "../features/marketing/PublicLayout";

export const Route = createFileRoute("/pricing")({
  staticData: { publicShell: true },
  loader: ({ context }) => loadMe(context.queryClient),
  component: Pricing,
});

function Pricing() {
  const me = Route.useLoaderData();
  return (
    <PublicLayout signedIn={me !== null}>
      <PricingPage signedIn={me !== null} />
    </PublicLayout>
  );
}
